<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  id: {
    type: String,
    required: true
  },
  options: {
    type: Array,
    required: true
  },
  required: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: 'Selecteer een optie'
  },
  icon: {
    type: String,
    default: 'tag'
  }
});

const emit = defineEmits(['update:modelValue']);

const updateValue = (event) => {
  emit('update:modelValue', event.target.value);
};
</script>

<template>
  <div class="relative">
    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
      <font-awesome-icon :icon="['fas', icon]" class="h-5 w-5 text-emerald-500" />
    </div>
    <div class="absolute inset-y-0 left-10 flex items-center pointer-events-none">
      <div class="h-4 w-px bg-black/30"></div>
    </div>
    <select 
      :id="id"
      :value="modelValue"
      @input="updateValue"
      :required="required"
      class="block w-full rounded-md border-gray-300 shadow-sm focus:outline-lime-400 sm:text-sm px-4 py-3 pl-12 bg-white appearance-none"
    >
      <option value="" disabled selected>{{ placeholder }}</option>
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>
    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-emerald-500">
      <font-awesome-icon :icon="['fas', 'chevron-down']" class="h-4 w-4" />
    </div>
  </div>
</template>

<style>
/* Add keyframes to the Tailwind config or to a base CSS file */
@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* Fix select placeholder color to match other input placeholders */
select option:first-child {
    color: #9CA3AF; /* text-gray-400 equivalent */
}

/* When Firefox doesn't recognize the first-child properly */
select option[value=""] {
    color: #9CA3AF;
}

/* Some browsers need this for select elements */
select:invalid {
    color: #9CA3AF;
}
</style>